// extracted by mini-css-extract-plugin
export default {"header":"Header_header__UJFzh","link":"Header_link__I4IDd","logo-container":"Header_logo-container__BATo+","logo":"Header_logo__EqVZr"};